module.exports = __webpack_public_path__ + "static/media/satellite.bd421b1a.png";